import React from 'react';
import { withStyles } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import styles from './styles';


const Privacy = (props) => {
    const { classes } = props;

    return (
        <Container maxWidth={false} className={classes.blockContainer}>
            <div className={classes.mainBlock}>
                <Typography variant="h1" className={classes.mainTitleText}>
                    Privacy for PINN Hub
                </Typography>
                <Typography variant="body1" className={classes.mainTitleDescription}>
                    Last updated: June 25, 2026
                </Typography>

                <Typography variant="h5" gutterBottom>
                    What this notice covers
                </Typography>
                <p>
                    NextGen PINN Hub is the current application for account management, project collaboration, solver sharing, and NeuroDiffEq-focused support workflows. This notice explains the main categories of information the app handles today.
                </p>

                <Typography variant="h5" gutterBottom>
                    Data we collect
                </Typography>
                <ul>
                    <li>Account details such as username, email address, profile fields, theme preference, and API keys.</li>
                    <li>Workspace data such as projects, solver metadata, uploaded artifacts, and publication history.</li>
                    <li>Operational data such as request logs, usage counters, browser session state, and support or reset-password emails.</li>
                </ul>

                <Typography variant="h5" gutterBottom>
                    How we use it
                </Typography>
                <ul>
                    <li>To authenticate users, deliver the web application, and maintain project permissions.</li>
                    <li>To store, retrieve, version, and share solver assets and related documentation.</li>
                    <li>To operate the PINNs Agent, enforce plan limits, and improve reliability and support.</li>
                </ul>

                <Typography variant="h5" gutterBottom>
                    What is public vs private
                </Typography>
                <p>
                    Published solutions and related summaries may be visible to other users. Private workspace content should only be visible to users with access to the corresponding project, subject to the current implementation and administrator controls in the current release.
                </p>

                <Typography variant="h5" gutterBottom>
                    Storage and retention
                </Typography>
                <p>
                    Account data and workspace metadata are stored in the application database. Solver files are stored in the configured model store path. We retain data while an account or workspace remains active unless deletion is requested or required by operational or legal needs.
                </p>

                <Typography variant="h5" gutterBottom>
                    Security
                </Typography>
                <p>
                    We use reasonable safeguards for authentication, API access, and deployment configuration, but no internet service can guarantee absolute security. Users should avoid uploading secrets, regulated data, or material they are not authorized to share.
                </p>

                <Typography variant="h5" gutterBottom>
                    Contact
                </Typography>
                <p>
                    Privacy or support questions can be sent to nextgenaischool@gmail.com.
                </p>
            </div>
        </Container>
    );
};

export default withStyles(styles)(Privacy);
